import React, { Component } from "react";
import ComparerRow from "./ComparerRow";

class ComparerSection extends Component {
  state = {};
  years = [
    "2000",
    "2002",
    "2004",
    "2006",
    "2008",
    "2010",
    "2012",
    "2014",
    "2016",
    "2018",
  ];

  createRowData = (count_d_var, count_r_var) => {
    return this.years.map((year) => {
      const availYears = this.props.data.map((el) => el.year);
      const index = availYears.indexOf(year);
      if (index > -1) {
        return {
          year: year,
          available: true,
          candidate_d: this.props.data[index].candidate_d,
          candidate_r: this.props.data[index].candidate_r,
          count_d: this.props.data[index][count_d_var],
          count_r: this.props.data[index][count_r_var],
        };
      } else {
        return {
          year: year,
          available: false,
        };
      }
    });
  };

  componentDidMount() {
    switch (this.props.type) {
      case "presidential":
        this.setState({
          rows: (
            <>
              <ComparerRow
                activator={this.props.activator}
                label="Northampton"
                data={this.createRowData("count_d_county", "count_r_county")}
              />
              <ComparerRow
                activator={this.props.activator}
                label="Pennsylvania"
                data={this.createRowData("count_d_state", "count_r_state")}
              />
              <ComparerRow
                activator={this.props.activator}
                label="United States"
                data={this.createRowData("count_d_overall", "count_r_overall")}
              />
            </>
          ),
        });
        break;
      case "senate":
        this.setState({
          rows: (
            <>
              <ComparerRow
                activator={this.props.activator}
                label="Northampton"
                data={this.createRowData("count_d_county", "count_r_county")}
              />
              <ComparerRow
                activator={this.props.activator}
                label="Pennsylvania"
                data={this.createRowData("count_d_overall", "count_r_overall")}
              />
            </>
          ),
        });
        break;
      case "congressional":
        this.setState({
          rows: (
            <>
              <ComparerRow
                activator={this.props.activator}
                label="Northampton"
                data={this.createRowData("count_d_county", "count_r_county")}
              />
              <ComparerRow
                activator={this.props.activator}
                label="District"
                data={this.createRowData("count_d_overall", "count_r_overall")}
              />
            </>
          ),
        });
        break;
      default:
        break;
    }
  }

  render() {
    return (
      <div className={`comparer-section${this.props.altBg ? " alt" : ""}`}>
        <div className="comparer-section-label">{this.props.label}</div>
        <div className="comparer-row-container">{this.state.rows}</div>
      </div>
    );
  }
}

export default ComparerSection;
